// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"50121b43","135":"012d5c1c","139":"206f2b15","229":"74570cd9","243":"9f4fffcc","402":"c0f3028f","698":"834bfb8c","711":"0bfaf09f","716":"0f2d8c7d"}[chunkId] + ".chunk.js";
};